// TODO:
// 1-Replace ImageWrapper with suitable tailwind classes.

import { Card, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { cn } from "utils/styling";

import { theme } from "../../styles/theme";
import { getAletrnativeImage } from "../../utils/buildingImages";
import { formatNumberBasedOnUser, valueOrAlternative } from "../../utils/namesManipulation";
import { EnergyEfficiencyClass } from "../EnergyEfficiencyClass";
import { Icon } from "../Icon";

const CardImageLabel = ({ className, label }) => {
  return (
    <Stack
      className={cn(
        "gap-1 rounded-ds-0-25x bg-lds-selection-strong p-1  capitalize text-lds-selection-on-selection",
        className
      )}
    >
      <Icon color="currentColor" iconName="Tree" />
      <span className="font-ds-number-regular-xs">{label}</span>
    </Stack>
  );
};

export const AssetCard = ({
  city,
  className,
  climatePositive,
  consumption,
  emission,
  energyClass,
  imgPath,
  lastModernized,
  name,
  onClick,
  type,
  year,
}) => {
  const { t } = useTranslation();

  return (
    <article className={className}>
      <Card onClick={onClick}>
        {/* image-container */}
        <div className="relative">
          {/* image-label */}
          {climatePositive && <CardImageLabel className="absolute right-2 top-2" label="Clima positive" />}
          <img
            className="h-48 w-full rounded-md object-contain object-center"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = getAletrnativeImage(type);
            }}
            src={imgPath}
          />
        </div>
        {/* header */}
        <h2 className="font-ds-headline-lg ml-2 mt-4 capitalize  ">{valueOrAlternative(name)}</h2>
        {/* content */}
        <Stack className="mx-2 mt-3 items-start justify-between pb-2">
          {/* Left column */}
          <ul className="w-2/5">
            {/* City */}
            <li className="">
              <Stack className="mb-1.5" spacing={theme.spacing(3)}>
                <Icon className="ml-[1px] mr-1" color="var(--color-foreground-secondary)" iconName="LocationIcon" />
                <p className="sentence-case short-text font-ds-body-regular-xs  ">{valueOrAlternative(city)}</p>
              </Stack>
            </li>
            {/* Type */}
            <li className="">
              <Stack className="mb-1.5" spacing={theme.spacing(3)}>
                <Icon color="var(--color-foreground-secondary)" iconName="BuildingTypeIcon" />
                <p className="sentence-case short-text font-ds-body-regular-xs  ">{t(valueOrAlternative(type))}</p>
              </Stack>
            </li>
            {/* Construction year */}
            <li className="">
              <Stack className="mb-1.5" spacing={theme.spacing(3)}>
                <Icon color="var(--color-foreground-secondary)" iconName="ConstructionIcon" />
                <p className="sentence-case short-text font-ds-body-regular-xs  ">
                  {valueOrAlternative(year)} {lastModernized && `(${lastModernized})`}
                </p>
              </Stack>
            </li>
            {/* Energy Label */}
            <li className="">
              <Stack spacing={theme.spacing(3)}>
                <Icon color="var(--color-foreground-secondary)" iconName="Energy" svgClassName="w-4 h-4" />
                {energyClass ? (
                  <EnergyEfficiencyClass className="!h-[2rem] !w-[2rem]" energyClass={energyClass} size="sm" />
                ) : (
                  <p className="text-lds-foreground-primary font-ds-number-regular-sm">
                    {t("AssetOverview.assetCard.pending")}
                  </p>
                )}
              </Stack>
            </li>
          </ul>
          {/* Right column */}
          <ul className="text-right">
            {/* Energy rating */}
            <li>
              <p className="uppercase text-lds-foreground-muted font-ds-label-md">
                {t("AssetOverview.assetCard.consumption")}
              </p>
              {consumption && (
                <p className="text-lds-foreground-number-initial font-ds-number-semibold-md">
                  {formatNumberBasedOnUser(consumption, 1)}
                  {" kWh/m²/a"}
                </p>
              )}
              {!consumption && <p className="short-text font-ds-body-regular-xs  ">{valueOrAlternative("")} </p>}
            </li>
            {/* Emission */}
            <li className="mt-3">
              <p className="text-lds-foreground-muted font-ds-label-md">{t("AssetOverview.assetCard.emission")}</p>
              {emission && (
                <p className="text-lds-foreground-number-initial font-ds-number-semibold-md">
                  {formatNumberBasedOnUser(emission, 1)}
                  {" kg CO₂/m²"}
                </p>
              )}
              {!emission && <p className="short-text font-ds-body-regular-xs  ">{valueOrAlternative("")} </p>}
            </li>
          </ul>
        </Stack>
      </Card>
    </article>
  );
};
